import React from "react";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import { showUrlDokumenProduktif } from "stores/PengajuanProduktif/function";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Step6Produktif() {
  const dispatch = useDispatch();
  const pengajuanProduktif = useSelector(
    (state) => state.pengajuanKoorProduktifReducer
  );
  const valDetail = !pengajuanProduktif.detailPengajuanProduktif.stepEnam
    ? []
    : pengajuanProduktif.detailPengajuanProduktif.stepEnam;
  // console.log(valDetail, "PPPPP");
  const [listUrlDokumen, setListUrlDokumen] = React.useState([]);
  const statusDokumen =
    pengajuanProduktif.listPengajuanByIdProduktif.statusDokumen;

  const handleClickPdf = (url) => {
    dispatch({
      type: "PREVIEW_DOKUMEN_PRODUKTIF",
      data: showUrlDokumenProduktif(dispatch, { urlImage: url }),
    });
  };

  React.useEffect(() => {
    let tmp = [];

    Object.entries(valDetail).forEach(([key, value]) => {
      // console.log(key, value, "QQSWQWAQQS");
      if (
        key !== "_id" &&
        key !== "id_pinjaman" &&
        key !== "createdAt" &&
        key !== "updatedAt"
      ) {
        const statusValue = statusDokumen[key];

        if (statusValue) {
          tmp.push({
            key: key,
            url: value,
            status: statusValue,
          });
        }
      }
    });

    // console.log(tmp, "Merged Object");
    setListUrlDokumen(tmp);
  }, [valDetail, statusDokumen]);

  // React.useEffect(() => {
  //   let tmp = [];
  //   let tmpStatusDokumen = [];
  //   Object.entries(valDetail).forEach(([key, value]) => {
  //     if (
  //       key != "_id" &&
  //       key != "id_pinjaman" &&
  //       key != "createdAt" &&
  //       key != "updatedAt"
  //     ) {
  //       const arrayStatusDokumen = Object.entries(statusDokumen);
  //       console.log(arrayStatusDokumen, " ARRAY STATUS");
  //       const foundArrayStatusDokumen = arrayStatusDokumen.find(
  //         ([keyStatusDokumen]) => {
  //           console.log(keyStatusDokumen, "KEY STATUS");
  //           keyStatusDokumen === "buku_nikah";
  //         }
  //       );
  //       if (foundArrayStatusDokumen) {
  //         const [keyValue] = foundArrayStatusDokumen;
  //         console.log(keyValue, "KEY VALUE");
  //         console.log(foundArrayStatusDokumen, "FOUND ARRAy");
  //       }
  //       tmp.push({
  //         key: key,
  //         url: value,
  //       });
  //     }
  //   });
  //   console.log(tmp, "QQQ");
  //   setListUrlDokumen(tmp);
  // }, []);

  return (
    <Col md="12" style={{ marginTop: 20 }}>
      <Card.Header>
        <Card.Title
          as="h4"
          style={{
            fontWeight: "bold",
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          Dokumen
          <hr></hr>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Card style={{ border: 0 }}>
          <div style={{ maxHeight: "450px", overflowY: "scroll" }}>
            <div className="row">
              <div className="col-12">
                <Label
                  style={{
                    fontSize: 16,
                    marginTop: 15,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  PDF
                </Label>
                {listUrlDokumen.map((val) => {
                  return (
                    <>
                      {/* <li> */}
                      {/* <Row>
                        <Col md={"4"}>
                          <Label
                            style={{
                              textTransform: "uppercase",
                              fontSize: 15,
                              fontWeight: "bold",
                              color: "#000000",
                            }}
                          >
                            <li>{val.key}</li>
                          </Label>
                        </Col>
                        <Col sm={"2"}>
                          <Button
                            className=" mr-0"
                            // variant="primary"
                            onClick={() => {
                              handleClickPdf(val.url);
                            }}
                            style={{
                              marginBottom: 10,
                              fontSize: 16,
                              backgroundColor: "#E0E6E1",
                              border: 0,
                              paddingLeft: 10,
                              paddingRight: 10,
                              color: "black",
                            }}
                          >
                            Lihat
                            <Row>
                              {val.status.statusKirim === 0 ? null : val.status
                                  .statusKirim === 1 ? (
                                <>
                                  <Col md={"4"}>
                                    <div>
                                      <i
                                        class="fas fa-check-circle"
                                        style={{
                                          fontSize: 23,
                                          color: "#22EB5B",
                                        }}
                                      ></i>
                                    </div>
                                  </Col>
                                </>
                              ) : (
                                <>
                                  <Col md={"4"}>
                                    <div>
                                      <i
                                        class="far fa-times-circle"
                                        style={{ fontSize: 23, color: "red" }}
                                      ></i>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                          </Button>
                        </Col>
                      </Row> */}
                      <Row>
                        <Col md={"4"}>
                          <Label
                            style={{
                              textTransform: "uppercase",
                              fontSize: 15,
                              fontWeight: "bold",
                              color: "#000000",
                            }}
                          >
                            <li>{val.key}</li>
                          </Label>
                        </Col>
                        <Col sm={"2"}>
                          <Button
                            className="mr-0"
                            onClick={() => {
                              handleClickPdf(val.url);
                            }}
                            style={{
                              marginBottom: 10,
                              fontSize: 16,
                              backgroundColor: "#B7C8D2",
                              border: 0,
                              paddingLeft: 15,
                              paddingRight: 15,
                              color: "#181919",
                              display: "flex",
                              alignItems: "center",
                              fontWeight: "bold",
                            }}
                          >
                            Lihat
                            {val.status.statusKirim === 0 ? null : val.status
                                .statusKirim === 1 ? (
                              <>
                                <div>
                                  <i
                                    className="fas fa-check-circle"
                                    style={{
                                      fontSize: 23,
                                      color: "#69F561",
                                      marginLeft: 20,
                                    }}
                                  ></i>
                                </div>
                              </>
                            ) : (
                              <>
                                <div>
                                  <i
                                    className="far fa-times-circle"
                                    style={{
                                      fontSize: 23,
                                      color: "#FF000D",
                                      marginLeft: 20,
                                    }}
                                  ></i>
                                </div>
                              </>
                            )}
                          </Button>
                        </Col>
                      </Row>

                      <Row>
                        <Col sm={"0"}>
                          <div>
                            <i
                              class="far fa-file-pdf"
                              style={{
                                fontSize: 40,
                                marginBottom: 10,
                                marginLeft: 20,
                              }}
                            ></i>
                          </div>
                        </Col>
                        <Col>
                          <div
                            style={{
                              color: "blue",
                              marginLeft: 15,
                              marginTop: 10,
                            }}
                          >
                            {val.url}
                          </div>
                        </Col>
                      </Row>

                      {/* <Row
                        style={{
                          fontSize: 15,
                          // color: "blue",
                        }}
                      ></Row> */}
                      {/* </li> */}
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </Card>
      </Card.Body>
    </Col>
  );
}
export default Step6Produktif;
